<template>
  <div :class="customClass">
    <div class="bundle-img-container">
      <div class="bundle-img-box">
        <img :src="data.image_url" />
      </div>
    </div>
    <div class="text-left bundle-name">
      <span> {{ data.name }}</span>
    </div>
    <div class="bundle-price">
      <div class="deposit-price">
        <template
          v-if="
            data.price_srp !== data.price_deposit &&
              data.price_deposit > 0
          "
        >
          ราคามัดจำ ฿{{ data.price_deposit | currency }}.-
        </template>
      </div>
      <div>
        <template v-if="delivery">
          ฿{{ data.price_ship | currency }}.-
        </template>
        <template v-else>
          ฿{{ data.price_store | currency }}.-
        </template>
      </div>

      <div
        v-if="delivery && data.price_ship !== data.price_srp"
        class="text-line-through normal-price"
      >
        ฿{{ data.price_srp | currency }} .-
      </div>
      <div
        v-else-if="!delivery && data.price_store !== data.price_srp"
        class="text-line-through normal-price"
      >
        ฿{{ data.price_srp | currency }} .-
      </div>
      <div v-else class="normal-price"></div>
    </div>

    <div class="bundle-button">
      <Button
        v-if="!select"
        @clickStop="$emit('click')"
        :disabled="!data.active"
        block
        depressed
        color="color-bnn"
        :title="data.active ? 'เพิ่ม' : 'สินค้าหมด'"
      />
      <v-btn
        v-else
        @click.stop="$emit('click')"
        :disabled="!data.active"
        block
        outlined
        class="v-btn-cancel-item"
      >
        <span class="v-text-cancel-item">
          นำออก
        </span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Button from '@/components/bnn/Button'
export default {
  components: {
    Button,
  },

  computed: {
    ...mapState({
      delivery: state => state.cart.delivery,
    }),

    customClass() {
      if (!this.data.active) {
        return 'bundle-card disabled'
      } else if (this.select) {
        return 'bundle-card'
      }
      return 'bundle-card'
    },
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    select: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="stylus" scoped>

.bundle-card
    position relative
    // border: 1px solid $color-bnn-gray-light
    background white
    border-radius: 8px;
    display: flex
    justify-content: center
    flex-wrap: wrap
    gap: 8px 0;
    // grid-template-columns: repeat(1, 1fr);
    height: fit-content;
    padding 0
    &:hover
        cursor pointer

    .bundle-img-container{
        padding 8px 8px 0
        .bundle-img-box {
            width 100%
            padding-top 100%
            height: auto
            position relative
        }
        img {
            position absolute
            top: 0
            left: 0
            width: 100%
            height: 100%
            object-fit: contain
            border-radius: 4px
        }
    }
    div {
        width 100%
    }

.bundle-name {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left
    font-size: 16px
    line-height: 20px
    height: 40px
    padding: 0 16px;
}

.bundle-card.disabled
    opacity 0.4
    cursor: not-allowed

.bundle-price {
    font-size: 16px
    font-weight: bold
    color: $color-bnn-red-2
    // margin-top: -1rem
    padding: 0 16px
    text-align: left
    bottom: 0
    left: 0
}

.bundle-button
    padding: 0 16px 16px

.bundle-card.select
    border: 1px solid $color-bnn-gray-medium;

.v-btn-cancel-item
  box-sizing: border-box
  font-weight: bold !important
  font-size: 0.875rem !important
  border-color: $color-bnn !important
  background-color: $color-fourth !important

.v-text-cancel-item
  color: $color-secondary-text

.normal-price
  color: $color-bnn-gray-medium-2
  font-size: 0.85rem
  text-align: left
  height: 22px

.deposit-price
  color: $color-bnn-gray-medium-2
  height: 22px
</style>
